export default __webpack_public_path__ + "static/media/V2-CARROUSEL_2.c9a9f402.png";